import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {MobileContainerBox} from "../boxes/mobile-container/mobile-container.box";
import {UserIconBox} from "../boxes/icon/user-icon.box";
import {UserBankrollBox} from "../boxes/bankroll/user-bankroll.box";
import React from "react";
import {FreePlayDotIndicatorBox} from "../boxes/free-play-dot-indicator/free-play-dot-indicator.box";
import {CyClass} from "../../../../../../common/cy-classes";

export const HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent = observer(
    class HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent extends OrbitComponent {
        private _onClick = () => {
            this.services.userMenu.openMenu();
        };

        private _renderFreePlayIndicator = () => {
            if(!this.services.freePlay.hasVouchers) {
                return null;
            }
            return (
                <FreePlayDotIndicatorBox className={CyClass('cy-free-play-indicator-dot')}/>
            )
        }

        private _captureElementRef = (element: HTMLDivElement) => {
            if(this.services.mediaQuery.lAndBelow) {
                this.services.freePlay.setFreePlayIndicatorDOMElementRef(element);
            }
        }

        componentWillUnmount() {
            super.componentWillUnmount();
            if(this.services.mediaQuery.lAndBelow) {
                this.services.freePlay.setFreePlayIndicatorDOMElementRef(null);
            }

        }

        render() {
            return (
                <MobileContainerBox onClick={this._onClick}
                                    ref={this._captureElementRef}
                                    className={CyClass('cy-balance-container-mobile')}>
                    <UserIconBox/>
                    {this._renderFreePlayIndicator()}
                    <UserBankrollBox>
                        {this.services.currency.formatMoney(this.services.walletProxy.totalBankroll)}
                    </UserBankrollBox>
                </MobileContainerBox>
            );
        }
    }
);